import { Injectable } from '@angular/core';

@Injectable()
export class SharedService {
    searchData = [];
    constructor() {
        this.searchData = [];
    }

    setSearchData(val: any[]) {
        this.searchData = val;
    }

    getSearchData() {
        return this.searchData;
    }
}